import { atom, swr } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
import toAssetAtom from './to-asset.js';
import feeAmountAtom from './fee-amount.js';
import { MAX_ALLOWED_SPREAD_PERCENTAGE, NEGATIVE_SPREAD_THRESHOLD, DEFAULT_HIGH_NETWORK_FEE_THRESHOLD_USD, } from '../form/constants.js';
import { spreadAtom } from './index.js';
import quoteAtom from './quote.js';
const highPriceImpactAtom = atom((get) => {
    const quote = get(swr(quoteAtom));
    if (quote.loading || !quote.data)
        return null;
    const spreadPercentage = get(spreadAtom);
    if (spreadPercentage <= MAX_ALLOWED_SPREAD_PERCENTAGE)
        return null;
    return {
        type: 'error',
        reason: 'HIGH_PRICE_IMPACT',
        payload: { spreadPercentage },
    };
});
const negativeSpreadAtom = atom((get) => {
    const quote = get(swr(quoteAtom));
    if (quote.loading || !quote.data)
        return null;
    const spreadPercentage = get(spreadAtom);
    if (spreadPercentage >= NEGATIVE_SPREAD_THRESHOLD)
        return null;
    return {
        type: 'error',
        reason: 'NEGATIVE_SPREAD',
        payload: { spreadPercentage },
    };
});
const highNetworkFeeAtom = atom((get, { selectors }) => {
    const quote = get(swr(quoteAtom));
    if (quote.loading || !quote.data)
        return null;
    const fromAsset = get(fromAssetAtom);
    const isEthereumNetwork = fromAsset.name === 'ethereum' || fromAsset.baseAsset.name === 'ethereum';
    if (!isEthereumNetwork)
        return null;
    const feeAmount = get(feeAmountAtom);
    const feeAssetName = fromAsset.feeAsset.name;
    const getUsdConversion = get(selectors.fiatBalances.createAssetConversionUsd(feeAssetName));
    const feeUsd = getUsdConversion(feeAmount);
    const remoteConfig = get(selectors.remoteConfig.data);
    const threshold = remoteConfig.infrastructure?.exchange?.highNetworkFeeThreshold ??
        DEFAULT_HIGH_NETWORK_FEE_THRESHOLD_USD;
    if (feeUsd < threshold)
        return null;
    return {
        type: 'warning',
        reason: 'HIGH_NETWORK_FEE',
        payload: { feeUsd, threshold },
    };
});
const remoteWarningAtom = atom((get, { selectors }) => {
    const fromAsset = get(fromAssetAtom);
    const toAsset = get(toAssetAtom);
    const getExchangeWarningOverride = get(selectors.exchange.remoteWarning);
    const { exchangeWarningText, exchangeWarningTitle } = getExchangeWarningOverride(fromAsset, toAsset);
    if (!exchangeWarningText || !exchangeWarningTitle)
        return null;
    return {
        type: 'warning',
        reason: 'WARNING',
        payload: { fromAsset, toAsset, text: exchangeWarningText, title: exchangeWarningTitle },
    };
});
const warningValidationAtoms = [
    highPriceImpactAtom,
    negativeSpreadAtom,
    highNetworkFeeAtom,
    remoteWarningAtom,
];
const warningValidationsAtom = atom((get) => {
    const validations = warningValidationAtoms.map((atom) => get(atom));
    return validations.filter((v) => v !== null);
});
export const warningAtom = atom((get) => get(warningValidationsAtom)[0] ?? null);
